import React from 'react';

import { Button } from '../../ui/button';
import { SECTION_LABELS, SectionKey } from '../constants';

interface SectionNavigationProps {
  activeSection: SectionKey;
  onSectionChange: (section: SectionKey) => void;
}

const SectionNavigation: React.FC<SectionNavigationProps> = ({
  activeSection,
  onSectionChange,
}) => {
  return (
    <nav className="py-1.5 mb-2">
      <div className="flex items-center justify-center gap-1 rounded-md border border-gray-200 bg-white p-1">
        {Object.entries(SECTION_LABELS).map(([key, label]) => {
          const sectionKey = key as SectionKey;
          const isActive = activeSection === sectionKey;

          return (
            <Button
              key={sectionKey}
              type="button"
              variant="ghost"
              size="sm"
              className={`
                w-full flex items-center justify-center gap-1.5 px-2 py-1.5
                text-xs font-medium whitespace-nowrap rounded
                border ${isActive ? 'border-gray-300 bg-gray-50 text-gray-900' : 'border-transparent text-gray-700 hover:bg-gray-50'}
              `}
              onClick={() => onSectionChange(sectionKey)}
              aria-label={`Go to ${label}`}
              tabIndex={0}
            >
              <span className="text-sm text-gray-400">•</span>
              <span>{label}</span>
            </Button>
          );
        })}
      </div>
    </nav>
  );
};

export default SectionNavigation;
